import {Component, Input} from '@angular/core';
import {BaseComponent} from "../../../shared/base.component";
import {SeriesAuditHistoryService} from "../series-audit-history.service";
import {Series} from "../../../_models/series";
import {takeUntil} from "rxjs/operators";
import {deepCopy} from "../../../lib/utils";
import {
    SeriesAuditBaseTableConfig,
    SeriesAuditHistoryBaseTableComponent
} from "../series-audit-history-base-table/series-audit-history-base-table.component";

import {StringDatePipe} from "../../../shared/pipes";

@Component({
    selector: 'series-audit-sub-hourly-data',
    templateUrl: './series-audit-sub-hourly-data.component.html',
    imports: [
    StringDatePipe,
    SeriesAuditHistoryBaseTableComponent
],
    styleUrl: './series-audit-sub-hourly-data.component.scss'
})
export class SeriesAuditSubHourlyDataComponent extends BaseComponent {
    @Input() series: Series;
    timestamp: string;
    config: SeriesAuditBaseTableConfig;

    constructor(private cps: SeriesAuditHistoryService) {
        super();
    }

    ngOnInit(): void {
        this.cps.$currentHour.pipe(takeUntil(this.onDestroy))
            .subscribe(hour => {
                this.timestamp = hour;
                this.loadSubHourlyData();
            })
    }

    loadSubHourlyData() {
        if (this.timestamp) {
            const start = new Date(this.timestamp);
            const end = (deepCopy(start)).addHours(1);
            //Update sub-hourly component input
            this.config = {type: 'sub_hourly', start: start, end: end}
        }
    }

    ngOnDestroy(): void {
        if (this.onDestroy) {
            this.onDestroy.next();
            this.onDestroy.unsubscribe();
        }
    }
}
